import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";
import { BRAND } from "@/config/brand";
import { Building2, CreditCard, Settings2, LogOut, ScrollText } from "lucide-react";

const LINKS = [
  { to: "/super", end: true, icon: Building2, label: "Entreprises", testid: "super-nav-orgs" },
  { to: "/super/facturation", icon: CreditCard, label: "Clients & Facturation", short: "Facturation", testid: "super-nav-billing" },
  { to: "/super/parametres-facturation", icon: Settings2, label: "Paramètres facturation", short: "Paramètres", testid: "super-nav-billing-settings" },
  { to: "/super/journal-notifications", icon: ScrollText, label: "Journal notifications", short: "Journal", testid: "super-nav-notification-log" },
];

export default function SuperLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-brand-800 text-white sticky top-0 z-10 shadow-md shadow-brand-900/20">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 h-16">
          <div className="flex items-center gap-3 min-w-0">
            <LogoMark size={36} onDark />
            <div className="leading-tight min-w-0"><span className="font-heading font-extrabold text-lg block">{BRAND.name}</span><span className="text-xs text-brand-200 truncate block">Console Super Admin SaaS</span></div>
          </div>
          <nav className="hidden md:flex items-center gap-1">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.testid}
                className={({ isActive }) => `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${isActive ? "bg-accent-500 text-white" : "text-brand-100 hover:bg-white/10"}`}>
                <l.icon className="w-4 h-4" />{l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-4">
            <span className="text-sm text-brand-100 hidden sm:inline">{user?.first_name} {user?.last_name}</span>
            <button data-testid="super-logout" onClick={() => { logout(); nav("/login"); }} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center"><LogOut className="w-4 h-4" /></button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8 pb-24 md:pb-8 animate-fade-in"><Outlet /></main>
      <nav data-testid="super-mobile-nav" className="md:hidden fixed bottom-0 inset-x-0 z-20 bg-white border-t border-slate-200 flex" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end} data-testid={`${l.testid}-mobile`}
            className={({ isActive }) => `flex-1 min-w-0 flex flex-col items-center gap-0.5 px-1 py-2 text-[11px] font-semibold ${isActive ? "text-accent-700" : "text-slate-400"}`}>
            <l.icon className="w-5 h-5" /><span className="truncate max-w-full">{l.short || l.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
